// Keep the invite's country selector and imported international prefixes in sync.
export const invitePhoneCountries = [
  { country: 'SE', code: '+46', label: 'se🇸🇪' },
  { country: 'US', code: '+1', label: 'us/ca🇺🇸🇨🇦' },
  { country: 'GB', code: '+44', label: 'gb🇬🇧' },
  { country: 'FI', code: '+358', label: 'fi🇫🇮' },
  { country: 'NO', code: '+47', label: 'no🇳🇴' },
  { country: 'DK', code: '+45', label: 'dk🇩🇰' },
  { country: 'ES', code: '+34', label: 'es🇪🇸' },
  { country: 'CH', code: '+41', label: 'ch🇨🇭' },
  { country: 'DE', code: '+49', label: 'de🇩🇪' },
  { country: 'FR', code: '+33', label: 'fr🇫🇷' },
  { country: 'BE', code: '+32', label: 'be🇧🇪' },
  { country: 'NL', code: '+31', label: 'nl🇳🇱' },
  { country: 'AU', code: '+61', label: 'au🇦🇺' },
  { country: 'NZ', code: '+64', label: 'nz🇳🇿' },
  { country: 'IS', code: '+354', label: 'is🇮🇸' },
  { country: 'EE', code: '+372', label: 'ee🇪🇪' },
  { country: 'LV', code: '+371', label: 'lv🇱🇻' },
  { country: 'LT', code: '+370', label: 'lt🇱🇹' },
  { country: 'IE', code: '+353', label: 'ie🇮🇪' },
  { country: 'LU', code: '+352', label: 'lu🇱🇺' },
  { country: 'AT', code: '+43', label: 'at🇦🇹' },
  { country: 'PT', code: '+351', label: 'pt🇵🇹' },
  { country: 'MT', code: '+356', label: 'mt🇲🇹' },
  { country: 'GR', code: '+30', label: 'gr🇬🇷' },
  { country: 'CY', code: '+357', label: 'cy🇨🇾' },
  { country: 'PL', code: '+48', label: 'pl🇵🇱' },
  { country: 'CZ', code: '+420', label: 'cz🇨🇿' },
  { country: 'LI', code: '+423', label: 'li🇱🇮' },
  { country: 'MC', code: '+377', label: 'mc🇲🇨' },
  { country: 'AD', code: '+376', label: 'ad🇦🇩' },
  { country: 'SM', code: '+378', label: 'sm🇸🇲' },
  { country: 'IT', code: '+39', label: 'it🇮🇹' },
  { country: 'SK', code: '+421', label: 'sk🇸🇰' },
  { country: 'HU', code: '+36', label: 'hu🇭🇺' },
  { country: 'SI', code: '+386', label: 'si🇸🇮' },
  { country: 'HR', code: '+385', label: 'hr🇭🇷' },
  { country: 'BA', code: '+387', label: 'ba🇧🇦' },
  { country: 'RS', code: '+381', label: 'rs🇷🇸' },
  { country: 'ME', code: '+382', label: 'me🇲🇪' },
  { country: 'MK', code: '+389', label: 'mk🇲🇰' },
  { country: 'AL', code: '+355', label: 'al🇦🇱' },
  { country: 'XK', code: '+383', label: 'xk🇽🇰' },
  { country: 'BG', code: '+359', label: 'bg🇧🇬' },
  { country: 'RO', code: '+40', label: 'ro🇷🇴' },
  { country: 'MD', code: '+373', label: 'md🇲🇩' },
  { country: 'UA', code: '+380', label: 'ua🇺🇦' },
  { country: 'BY', code: '+375', label: 'by🇧🇾' },
];

export function getInviteCountryCode(country?: string): string {
  const normalized = (country || 'SE').toUpperCase();
  if (normalized === 'CA') { return '+1'; }
  const match = invitePhoneCountries.find(option => option.country === normalized);
  return match ? match.code : '+46';
}

export function normalizeInviteContactPhone(value: string, defaultCountryCode: string): { countryCode: string; phone: string } | null {
  // Formatting is safe to remove. Reject extensions/letters instead of silently
  // appending them to the recipient's number.
  const compact = value.trim().replace(/[\s().-]/g, '').replace(/^00/, '+');
  if (!/^\+?\d+$/.test(compact)) { return null; }
  let countryCode = defaultCountryCode;
  let phone = compact;
  if (compact.charAt(0) === '+') {
    const match = invitePhoneCountries.find(option => compact.indexOf(option.code) === 0);
    if (!match) { return null; }
    countryCode = match.code;
    phone = compact.slice(countryCode.length);
  }
  if (!invitePhoneCountries.some(option => option.code === countryCode)) { return null; }
  if (countryCode === '+1' && phone.length === 11 && phone.charAt(0) === '1') {
    phone = phone.slice(1);
  } else if (countryCode === '+36' && phone.indexOf('06') === 0) {
    phone = phone.slice(2);
  } else if (!['+39', '+378'].includes(countryCode)) {
    // Italy and San Marino retain a leading zero in international numbers.
    phone = phone.replace(/^0/, '');
  }
  return phone ? { countryCode, phone } : null;
}



// WEBPACK FOOTER //
// ./src/helpers/invitePhone.ts